import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { AskEvaClient } from 'api-clients/ai-api-client';
import { ApplicantClient } from 'api-clients/applicant-api-client';
import { DiscussionClient } from 'api-clients/discussion-api-client';
import { PolicyClient } from 'api-clients/policy-api-client';
import { EvaSuggestedPromptsService } from 'src/app/eva-sidebar/eva-suggested-prompts/eva-suggested-prompts.service';
import { EvaSharedApisService } from 'src/app/eva-sidebar/shared/services/eva-shared-apis.service';
import { EvaSidebarContentComponent } from './eva-sidebar-content/eva-sidebar-content.component';
import { EvaSidebarHeaderComponent } from './eva-sidebar-header/eva-sidebar-header.component';
import { EvaSidebarService } from './eva-sidebar.service';
import { EvaSourcePopoverService } from './ez-source-popover/eva-source-popover.service';
import { EvaPageContextService } from './shared/services/eva-page-context.service';
import { EvaQuestionAnswerService } from './shared/services/eva-question-answer.service';

@Component({
  selector: 'ez-eva-sidebar',
  imports: [
    CommonModule,
    EvaSidebarHeaderComponent,
    EvaSidebarContentComponent,
  ],
  templateUrl: './eva-sidebar.component.html',
  styleUrl: './eva-sidebar.component.scss',
  host: {
    class: 'eva-theme',
  },
  providers: [
    EvaQuestionAnswerService,
    EvaSuggestedPromptsService,
    EvaSourcePopoverService,
    EvaPageContextService,
    EvaSharedApisService,
    { provide: AskEvaClient, useValue: new AskEvaClient() },
    { provide: ApplicantClient, useValue: new ApplicantClient() },
    { provide: DiscussionClient, useValue: new DiscussionClient() },
    { provide: PolicyClient, useValue: new PolicyClient() },
  ],
})
export class EvaSidebarComponent {
  readonly #evaSidebarService = inject(EvaSidebarService);
  protected readonly isOpen = this.#evaSidebarService.isOpen;
  protected readonly isExpanded = this.#evaSidebarService.isExpanded;
  protected readonly isClosing = computed(() => !this.isOpen());
}
